import api from './api';

export const newsService = {
  getPublicNews: () => api.get('/news'),
  getNewsByKey: (key) => api.get(`/news/${key}`),
  getAllNewsAdmin: () => api.get('/news/admin/all'),
  createNews: (data) => api.post('/news', data),
  updateNews: (id, data) => api.put(`/news/${id}`, data),
  deleteNews: (id) => api.delete(`/news/${id}`)
};
